// src\providers\PasswordGate.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';

const PasswordGate = ({ children }) => {
    const [input, setInput] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(
        localStorage.getItem('access_granted') === 'true'
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        if (input === '1') {
            localStorage.setItem('access_granted', 'true');
            setIsAuthenticated(true);
        } else {
            alert('Incorrect Password');
        }
    };

    if (isAuthenticated) {
        return <React.Fragment>{children}</React.Fragment>;
    }

    return (
        <div style={styles.container}>
            <form onSubmit={handleSubmit} style={styles.form}>
                <h2 style={{ color: '#333' }}>Private Access</h2>
                <p style={{ color: '#666', marginBottom: '20px' }}>
                    Please enter the access code to view the site.
                </p>
                <input
                    type="password"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Enter code"
                    style={styles.input}
                    autoFocus
                />
                <button type="submit" style={styles.button}>
                    Verify
                </button>
            </form>
        </div>
    );
};

// This fixes the "children is missing in props validation" error
PasswordGate.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        position: 'fixed',
        top: 0,
        left: 0,
        backgroundColor: '#f0f2f5',
        zIndex: 9999, // Ensure it covers everything
    },
    form: {
        padding: '40px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: '400px',
        width: '90%',
    },
    input: {
        padding: '12px',
        width: '100%',
        marginBottom: '20px',
        borderRadius: '6px',
        border: '1px solid #ddd',
        fontSize: '16px',
        boxSizing: 'border-box',
    },
    button: {
        padding: '12px 30px',
        backgroundColor: '#1976d2',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        width: '100%',
    },
};

export default PasswordGate;